<div id="layout" class="theme-cyan">
  <app-chat-leftmenu></app-chat-leftmenu>

  <!-- Main Body: Content -->
  <div class="main px-xl-5 px-lg-4 px-3">

    <!-- chat body -->
    <div class="chat-body">

      <!-- Page Default -->
      <div class="chat d-flex justify-content-center align-items-center h-100 text-center py-xl-4 py-md-3 py-2">
        <div class="container-fluid">

          <div class="avatar lg avatar-bg me-auto ms-auto mb-5">
            <img class="avatar lg rounded-circle border" src="../assets/images/user.png" alt="" />
            <span class="a-bg-1"></span>
            <span class="a-bg-2"></span>
          </div>

          <h5 class="fw-bold">Hey, Robert!</h5>
          <p>Please select a chat to start messaging.</p>
        </div>
      </div>
      <!-- End Page Default -->

    </div>
    <!-- End chat body -->

  </div>
  <!-- Main Body: Content -->
</div>
